(function(){
'use strict';

scMemberSearchModel.$inject = ["scResourceSearchModel"];
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function scMemberSearchModel(scResourceSearchModel) {
  return function (_scResourceSearchMode) {
    _inherits(MemberSearchModel, _scResourceSearchMode);

    function MemberSearchModel(fields, queryParams) {
      _classCallCheck(this, MemberSearchModel);

      return _possibleConstructorReturn(this, (MemberSearchModel.__proto__ || Object.getPrototypeOf(MemberSearchModel)).call(this, 'members', fields, queryParams));
    }

    /**
     * {@inheritdoc}
     */


    _createClass(MemberSearchModel, [{
      key: 'getReadableTypeName',
      value: function getReadableTypeName() {
        return 'members';
      }

      /**
       * {@inheritdoc}
       */

    }, {
      key: 'getName',
      value: function getName(resource) {
        return resource.first_name + ' ' + resource.last_name;
      }

      /**
       * {@inheritdoc}
       */

    }, {
      key: 'getDescription',
      value: function getDescription() {
        return '';
      }
    }]);

    return MemberSearchModel;
  }(scResourceSearchModel);
}

angular.module('classy').factory('scMemberSearchModel', scMemberSearchModel);
})();